import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-autocomplete',
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule],
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent {
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() filterCtrl: FormControl<string>;
  @Input() filteredList$: Observable<any[]>;
  @Input() isLoading: boolean = false;
  @Input() error: string | null = null;
  @Input() displayKey: string = ''; // clé utilisée pour l'affichage dans mat-option
  @Output() elementSelected = new EventEmitter<any>();
  @Output() searchChanged = new EventEmitter<any>();
  @Output() reset = new EventEmitter<void>();
  @Input() valueKey!: string;

  clearSearch() {
    this.filterCtrl.reset();
    this.isLoading = false;
    this.searchChanged.emit('');
    this.reset.emit();
  }

  onOptionSelected(element: any) {
    const displayValue = this.displayKey !== '' ? element[this.displayKey] : element;
    this.filterCtrl.setValue(displayValue, { emitEvent: false });
    this.elementSelected.emit(element);
  }

  protected onSearchChanged($event: KeyboardEvent) {
    this.searchChanged.emit(this.filterCtrl.value);
  }
}
